var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.globalBanner.isVisible)?_c('div',{staticClass:"global-banner"},[_c('div',{staticClass:"container"},[_vm._v(" "+_vm._s(_vm.$store.getters.globalBanner.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }